import React from "react";
import { withRouter } from "react-router";
import Banner from "../../components/common/banner";
import Footer from "../../components/common/footer";
import FaqCard from "../../components/common/faqCard";
import styles from "./faqPage.module.scss";

const AppFaqPage = (props) => {
  // const { location, history } = props;

  const imageUrl =
    "https://firebasestorage.googleapis.com/v0/b/noosaapp.appspot.com/o/assets%2Fbanner_image_form.png?alt=media";

  const faqStyles = { textAlign: 'left' };

  return (
    <div className={styles.landingfaqContainer}>
      <Banner heading="WTD Noosa" subHeading="FAQs" imageUrl={imageUrl} />
      {/* <div className={styles.heroImage} style={bannerImage}> */}
      <div className={styles.landingfaqBody}>
        <div>
          <FaqCard
            containerAlign={faqStyles}
            question="How can I add to my favorites list?"
          >
            <li>
              For quick access to all the things you like best, sign in, or sign
              up to create an account, once signed in you can start adding to
              your favorites.
            </li>
          </FaqCard>
          <FaqCard
            containerAlign={faqStyles}
            question="Some businesses only have directions, website or phone?"
          >
            <li>
              For some of the Businesses in Noosa, not all details are
              available. WTD Noosa continues to monitor and provide the most up
              to date and relevant information on all local businesses. If you
              feel there is something misleading or incorrect please raise an
              issue to{" "}
              <a href="mailto:exempli.gratia.webdesign@gmail.com">
                app support
              </a>
              .
            </li>
          </FaqCard>
          <FaqCard
            containerAlign={faqStyles}
            question="The information provided was incorrect?"
          >
            <li>
              WTD Noosa continues to monitor and provide the most up to date and
              relevant information on all local businesses. We understand the
              information provided is what makes the app useful. We will always
              endevour to rectify any incorrect information quckly. Please let
              us know with the following info, if you find something not quite
              right. Please make sure your app is up to date before reporting an
              issue with the information, as this may solve the problem for you.
            </li>
            <li>1. Location/Business/Event Name</li>
            <li>2. The date when you noticed the issue.</li>
          </FaqCard>
          <FaqCard
            containerAlign={faqStyles}
            question="How can I request a new feature in the app?"
          >
            <li>
              WTD Noosa will soon provide a place on this website where you can
              submit a feature request. You can also make a request in reviewing
              the app on the apple app store or google play store.
            </li>
          </FaqCard>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default withRouter(AppFaqPage);
